import React from 'react';
import { TitleBar, Text } from '@redacted/react-components';
import { Box } from '@material-ui/core';

function FileNotFound() {
  return (
    <Box width="75%" margin="0 auto">
      <TitleBar title="File Not Found" />
      <Text>There is nothing here.</Text>
    </Box>
  );
}

export default FileNotFound;
